/* LUYA · menús con fotos (Colecciones, Amor y compromiso, Joyería masculina, etc.)
   Velocidad y variedad:
   1) Cada tarjeta tiene su foto SIGUIENTE ya descargada antes de que abras el submenú,
      así la foto aparece al instante.
   2) La foto cambia en cada apertura. Se usa una baraja: no se repite ninguna foto hasta
      haber mostrado todas las de esa tarjeta, y nunca se repite dos veces seguidas.
   3) Si una foto falla, se prueba otra automáticamente.
   4) En escritorio, los menús del encabezado se abren al pasar el mouse.
   5) Videos de la tienda: volumen inicial al 30% y reproducción en bucle. */
(() => {
  if (window.luyaVisualMenuInstalled) return;
  window.luyaVisualMenuInstalled = true;

  const CARD = '.luya-collection-menu-card';
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover)');

  const shuffle = (list) => {
    for (let i = list.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [list[i], list[j]] = [list[j], list[i]];
    }
    return list;
  };

  const photos = (card) => {
    if (!card._photos) {
      let list = [];
      try { list = JSON.parse(card.dataset.randomImages || '[]'); } catch (error) { list = []; }
      card._photos = Array.from(new Set(list.filter(Boolean)));
    }
    return card._photos;
  };

  const usable = (card) => photos(card).filter((src) => !(card._failed && card._failed.has(src)));

  // Siguiente foto de la baraja (sin repetir hasta agotar todas; nunca igual a la actual).
  const takeNext = (card) => {
    const list = usable(card);
    if (!list.length) return null;
    if (list.length === 1) return list[0];
    card._queue = (card._queue || []).filter((src) => list.includes(src));
    if (!card._queue.length) {
      card._queue = shuffle(list.slice());
      if (card._queue[0] === card._current) card._queue.push(card._queue.shift());
    }
    return card._queue.shift();
  };

  // Descarga y decodifica la foto que seguirá, sin mostrarla todavía.
  const preload = (card) => {
    if (card._next) return;
    const src = takeNext(card);
    if (!src) return;
    card._next = src;
    const probe = new Image();
    probe.decoding = 'async';
    probe.src = src;
    if (probe.decode) probe.decode().catch(() => {});
  };

  const startState = (card) => {
    if (card._current === undefined) {
      const img = card.querySelector('img');
      card._current = img ? img.getAttribute('src') : null;
    }
  };

  // Muestra la foto precargada y deja lista la siguiente.
  const show = (card) => {
    const img = card.querySelector('img');
    if (!img || !card.hasAttribute('data-random-images')) return;
    const now = Date.now();
    if (card._shownAt && now - card._shownAt < 150) return;
    startState(card);
    const src = card._next || takeNext(card);
    if (!src) return;
    card._shownAt = now;
    card._next = null;
    card._current = src;
    img.style.visibility = '';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.loading = 'eager';
    img.src = src;
    card.dataset.lastImage = src;
    setTimeout(() => preload(card), 0);
  };

  const warm = (root) => {
    if (!root) return;
    root.querySelectorAll(CARD).forEach((card) => {
      if (!card.hasAttribute('data-random-images')) return;
      startState(card);
      preload(card);
    });
  };

  // Reemplaza choosePhotos() del carrusel original para que todos los menús usen esta lógica.
  const patch = () => {
    const Carousel = window.customElements.get('luya-collections-carousel');
    if (!Carousel || Carousel.prototype._luyaPatched) return;
    Carousel.prototype._luyaPatched = true;
    Carousel.prototype.choosePhotos = function choosePhotos() {
      this.querySelectorAll(CARD).forEach(show);
      if (typeof this.update === 'function') this.update();
    };
  };
  patch();
  window.customElements.whenDefined('luya-collections-carousel').then(patch);

  // El panel ancho (escritorio) se pega justo debajo del encabezado.
  const placePanel = (details) => {
    const panel = details.querySelector('.header__submenu.luya-collections-panel');
    const header = document.querySelector('header');
    if (panel && header) panel.style.top = header.getBoundingClientRect().bottom + 'px';
  };

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    placePanel(details);
    details.querySelectorAll('luya-collections-carousel').forEach((carousel) => {
      if (carousel.closest('details') === details) {
        if (typeof carousel.choosePhotos === 'function') carousel.choosePhotos();
      } else {
        warm(carousel);
      }
    });
  }, true);

  // Intención de abrir el menú: precargar las fotos de lo que sigue.
  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest) return;
    if (event.target.closest('header-drawer summary')) warm(document.querySelector('header-drawer'));
  }, true);

  let navWarmed = false;
  const warmNav = () => {
    if (navWarmed) return;
    navWarmed = true;
    warm(document.querySelector('.header__inline-menu'));
  };

  // Las fotos que fallan se reemplazan por otra (hasta 6 intentos).
  document.addEventListener('error', (event) => {
    const img = event.target;
    if (!(img instanceof HTMLImageElement) || !img.closest) return;
    const card = img.closest('luya-collections-carousel ' + CARD);
    if (!card) return;
    card._failed = card._failed || new Set();
    card._failed.add(img.getAttribute('src'));
    const options = usable(card);
    if (!options.length || card._failed.size > 6) { img.style.visibility = 'hidden'; return; }
    const src = options[Math.floor(Math.random() * options.length)];
    card._current = src;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  }, true);

  // Escritorio: abrir al pasar el mouse, cerrar al salir (con un pequeño margen de tiempo).
  let closeTimer = null;
  const closeAll = (except) => {
    document.querySelectorAll('header-menu > details[open]').forEach((details) => {
      if (details.parentElement !== except) details.removeAttribute('open');
    });
  };
  const openMenu = (menu) => {
    const details = menu.querySelector(':scope > details');
    if (!details || details.open) return;
    closeAll(menu);
    details.open = true;
  };

  document.addEventListener('mouseover', (event) => {
    if (!desktop.matches || !event.target.closest) return;
    const menu = event.target.closest('header-menu');
    if (!menu) return;
    warmNav();
    clearTimeout(closeTimer);
    openMenu(menu);
  });

  document.addEventListener('mouseout', (event) => {
    if (!desktop.matches || !event.target.closest) return;
    const menu = event.target.closest('header-menu');
    if (!menu) return;
    if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => closeAll(null), 250);
  });

  // Con el mouse, un clic en el título no debe cerrar el panel que ya se abrió solo.
  document.addEventListener('click', (event) => {
    if (!desktop.matches || !event.target.closest) return;
    const summary = event.target.closest('header-menu > details > summary');
    if (!summary) return;
    event.preventDefault();
    openMenu(summary.closest('header-menu'));
  }, true);

  // Escritorio con buena conexión: dejar fotos listas cuando el navegador esté libre.
  const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
  window.addEventListener('load', () => {
    idle(() => {
      const saveData = navigator.connection && navigator.connection.saveData;
      if (desktop.matches && !saveData) warmNav();
    }, { timeout: 4000 });
  });

  // Videos de la tienda: volumen inicial 30% y bucle infinito (una sola vez por video,
  // así el cliente puede cambiar el volumen después).
  const tuneVideo = (video) => {
    if (!(video instanceof HTMLVideoElement) || video._luyaTuned) return;
    video._luyaTuned = true;
    video.loop = true;
    video.setAttribute('loop', '');
    video.volume = 0.3;
  };
  ['loadedmetadata', 'play'].forEach((type) =>
    document.addEventListener(type, (event) => tuneVideo(event.target), true));
  document.querySelectorAll('video').forEach(tuneVideo);
})();
